require('./_bootstrap');
require('cookieconsent');
require('./_navbar');

/**
 * Here goes scripts, that will be executed on every page.
 * Scripts, that needs to bu run on particular pages should be
 * placed in route folders above this file.
 */

$.fn.dataTable.ext.classes.sPageButton = 'btn btn-purple btn-thin ml-5';

$(() => {
  $('#lnswitcher').lnswitcher({
    onSelect: (selected) => {
      window.location.href = setCountryUrl + selected;
    }
  });

  $('#lnswitcher_lang').lnswitcher({
    onSelect: (selected) => {
      window.location.href = setLanguageUrl + selected;
    }
  });

  ;

  window.addEventListener('load', () => {
    const cookieLangs = ['en_Europe', 'en_GB', 'en_IE'];
    let enabled = false;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const pageLanguage = $('#lnswitcher').find('.value').html();
    const userCookieAccepted = '<?php echo $this->layout()->cookieAccepted ?>' === '1';

    if (!userCookieAccepted) {
      if (cookieLangs.indexOf(pageLanguage) !== -1) {
        enabled = true;
      } else if (timezone.indexOf('Europe') !== -1) {
        enabled = true;
      }
    }

    window.cookieconsent.initialise({
      enabled,
      palette: {
        popup: {
          background: '#f59825'
        },
        button: {
          background: '#5649d7',
          text: '#fff'
        }
      },
      theme: 'classic',
      onStatusChange() {
        if (this.hasConsented()) {
          $.get('/accept-cookies', null, (e) => {
            console.log(e);
          });
        }
      }
    });
  });
});

$(() => {
  const oldXHR = window.XMLHttpRequest;

  function newXHR() {
    const realXHR = new oldXHR();

    realXHR.addEventListener('readystatechange', (data) => {
      if (data.target.readyState == 4) {
        try {
          const jsonObject = JSON.parse(data.target.response);

          if (typeof jsonObject.redirectToUrl != 'undefined') {
            window.location.href = jsonObject.redirectToUrl;

            return false;
          }
        } catch(err) {}
      }
    }, false);

    return realXHR;
  }

  $('body').tooltip({
    selector: '.btooltip[title]'
  });

  window.XMLHttpRequest = newXHR;
});
